import { render, staticRenderFns } from "./CallForBidsMsg.vue?vue&type=template&id=eeb9a944&scoped=true&"
import script from "./CallForBidsMsg.vue?vue&type=script&lang=js&"
export * from "./CallForBidsMsg.vue?vue&type=script&lang=js&"
import style0 from "./CallForBidsMsg.vue?vue&type=style&index=0&id=eeb9a944&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb9a944",
  null
  
)

export default component.exports